import { Spacing } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Utils } from '@genial/utils';

export const mapCaptions = (
  investment: Record<string, boolean | any>
): IconographyTypes.Option[] => {
  const captionKeys: Record<string, string> = {
    qualifiedInvestor: 'QualifiedClient',
    closedFund: 'Locked',
    professionalInvestor: 'ProfessionalInvestor',
    dailyLiquidity: 'Liquidity',
    taxExempt: 'IncomeTaxExempt',
    fgcProtected: 'Fgc',
  };

  return Object.keys(captionKeys)
    .filter((key) => investment[key])
    .map((key) => captionKeys[key]) as IconographyTypes.Option[];
};

const flatListMaxH = { base: '700px', sm: '600px', lg: '460px' };
const contentContainerStyle = {
  paddingBottom: Utils.Token.ToInt(Spacing, 'inset.nano'),
};

export const flatListProps = {
  maxToRenderPerBatch: 20,
  updateCellsBatchingPeriod: 5,
  showsVerticalScrollIndicator: false,
  maxH: flatListMaxH,
  onEndReachedThreshold: 0.4,
  contentContainerStyle,
};

export const confirmMessageProps = {
  title: 'Atenção',
  icon: 'Warning',
  iconColor: 'feedback.attention.default',
  confirmText: 'Continuar',
  confirmColor: 'feedback.error.default',
  description: 'Esta ação irá cancelar a solicitação.\nDeseja continuar mesmo assim?',
} as const;

export const participateConversationComponentIsVisible = false;

export * from './customer';
